var _react_refresh_temp_1;
_react_refresh_temp_1 = $RefreshSig$();
import { useState } from 'react';
export const useWizard = ({ initialWizardStep, onWizardCancel, onWizardSuccess, }) => {
    _react_refresh_temp_1();
    const [wizardStep, setWizardStep] = useState(initialWizardStep);
    return {
        onWizardCancel,
        onWizardSuccess,
        setWizardStep,
        wizardStep,
    };
};
_react_refresh_temp_1(useWizard, "p0bn5TT5KrrtHeIU6yhUoSDnnAE=");
